import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import is from 'is_js';
import PropTypes from 'prop-types';
import { connect, Grid, PrivilegeChecker } from 'omni-common-ui';
import CICCategoryCard from 'components/CICCategoryCard';
import NoContentMessage from 'components/NoContentMessage';
import Privileges from 'domain/Privileges';
import { actions as CoveredInClassActions, accessors as CIC } from 'data/CoveredInClass';
import { actions as CoveredInClassTemplateActions } from 'data/CoveredInClass/Template';
import InternalNotes from './InternalNotes';

const SAVE = 'save';
const IS_EDITING = 'isEditing';

class GrammarPro extends PureComponent {
  constructor() {
    super();
    this._getModeAndIndex = this._getModeAndIndex.bind(this);
    this.state = {
      activities: [],
    };
  }

  componentDidMount() {
    this._setUpData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this._setUpData(nextProps);
    if (this.props.mode !== nextProps.mode &&
      nextProps.mode === SAVE) {
      const {
        cic,
        push,
        buildRouteWithContext,
        fetchCoveredInClass,
        publishCoveredInClass,
        sessionPlanId,
      } = this.props;

      const activities = this.state.activities.map((category) => {
        const checkeditems = category.cicCategoryItems.filter((item) => item.isChecked);
        return Object.assign(category, {
          cicCategoryItems: checkeditems,
        });
      });

      const cicToPublish = Object.assign(cic, {
        cicCategories: activities,
      });
      publishCoveredInClass([cicToPublish], sessionPlanId).then(
        () => {
          fetchCoveredInClass(sessionPlanId).then(() =>
            push(buildRouteWithContext({ mode: '' })));
        }
      );
    }
  }

  _getModeAndIndex() {
    const { mode, index } = this.props;
    return { mode, index };
  }

  _onChangeMode(modeAndIndex) {
    const { mode, index = '' } = modeAndIndex;
    const { push, buildRouteWithContext } = this.props;
    push(buildRouteWithContext({ mode, index }));
  }

  _onComponentMounted(_cmpnt) {
    this.internalNotesPartComponent = _cmpnt;
  }

  _onCICItemChanged(categoryId, itemId, value) {
    const activitiesToUpdate = [...this.state.activities];
    const category = activitiesToUpdate.find((c) => c.cicCategoryId === categoryId);
    const cicItems = category.cicCategoryItems;
    const itemIndex = cicItems.findIndex((item) => item.cicCategoryItemId === itemId);
    const itemUpdated = Object.assign(cicItems[itemIndex], { isChecked: value });
    cicItems[itemIndex] = itemUpdated;
    this.setState({ activities: activitiesToUpdate });
  }

  _renderCIC(activities, isEdit) {
    if (Array.isArray(activities) && activities.length !== 0) {
      return activities.map((category) =>
        <Grid.Item xs={12} sm={12} md={6}>
          <CICCategoryCard title={category.cicCategoryName}
              categoriesList={category.cicCategoryItems}
              onItemCheck={
                (categoryId, itemId, value) => this._onCICItemChanged(categoryId, itemId, value)
              }
              isEdit={isEdit} />
        </Grid.Item>
      );
    }
    return <NoContentMessage text="No new course content was covered." />;
  }

  _setUpData(props) {
    if (Array.isArray(props.activities)) {
      this.setState({
        activities: props.activities.map((category) => {
          const cicCategoryItems = category.cicCategoryItems.map(
            (item) => Object.assign(item, { cicCategoryId: category.cicCategoryId })
          );
          return Object.assign(category, { cicCategoryItems });
        }),
      });
    } else {
      this.setState({ activities: [] });
    }
  }

  render() {
    const { sessionPlanId, hasSaved, isNotFutureSession, hasEditPriviledge } = this.props;
    const isEdit = is.existy(hasSaved) &&
      ! hasSaved &&
      isNotFutureSession &&
      hasEditPriviledge;
    return <Grid outerMargin>
      <Grid.Group>
        <InternalNotes sessionPlanId={sessionPlanId}
            onComponentMounted={(_cmpnt) => this._onComponentMounted(_cmpnt)}
            modeAndIndex={this._getModeAndIndex()}
            onChangeMode={(modeAndIndex) => this._onChangeMode(modeAndIndex)} />
        {this._renderCIC(this.state.activities, isEdit)}
      </Grid.Group>
    </Grid>;
  }

}


function mapDispatchToProps(dispatch) {
  return Object.assign(
    {},
    bindActionCreators(CoveredInClassActions, dispatch),
    bindActionCreators(CoveredInClassTemplateActions, dispatch),
  );
}

function mapStateToProps(state, ownProps) {
  const { sessionPlanId, mode, groupId } = ownProps;
  const hasSaved = CIC.hasSaved(state, sessionPlanId);
  const cics = getCICs(mode, state, sessionPlanId);
  const cic = getCIC(cics);
  const activities = getActivities(cic);
  const isNotFutureSession = CIC.isNotFutureSession(state, { groupId, sessionPlanId });
  const hasEditPriviledge = PrivilegeChecker.hasPrivilege(state,
    Privileges.CoveredInClass.MarkAndPublish);
  return { activities, cic, hasSaved, isNotFutureSession, hasEditPriviledge };
}

function getActivities(cic) {
  if (is.existy(cic)) {
    if (is.existy(cic) && is.existy(cic.cicCategories) && cic.cicCategories.length !== 0) {
      return cic.cicCategories;
    }
  }
}

function getCIC(cics) {
  if (is.existy(cics)) {
    return cics.toList().get(0) && cics.toList().get(0).toJSON();
  }
}

function getCICs(mode, state, sessionPlanId) {
  const hasSaved = CIC.hasSaved(state, sessionPlanId);
  return (mode !== IS_EDITING && hasSaved) ?
    CIC.getCoveredInClassObject(state, sessionPlanId) :
    CIC.getCoveredInClassTemplate(state, sessionPlanId);
}

GrammarPro.propTypes = {
  activities: PropTypes.array,
  cic: PropTypes.object,
  buildRouteWithContext: PropTypes.func,
  publishCoveredInClass: PropTypes.func,
  fetchCoveredInClassIfNeeded: PropTypes.func,
  fetchCoveredInClassTemplateIfNeeded: PropTypes.func,
  fetchCoveredInClass: PropTypes.func,
  mode: PropTypes.string,
  index: PropTypes.string,
  push: PropTypes.func,
  sessionPlanId: PropTypes.string,
  hasSaved: PropTypes.bool,
  isNotFutureSession: PropTypes.bool,
  hasEditPriviledge: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(GrammarPro);



// WEBPACK FOOTER //
// ./containers/Group/SessionReport/GrammarPro/index.jsx